// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qr {
  position: fixed;
  bottom: 30px;
  right: 20px;
  background-color: var(--orwi-qr-button-color);
  display: flex;
  width: 60px;
  height: 60px;
  color: white;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: var(--orwi-shadow);
  border: 2px solid white;
  z-index: 102;
}

.orwi-actio-backdrop {
  background-color: rgba(171, 172, 173, 0.6196078431);
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 100;
  top: 0px;
}

.anim-button {
  background-color: transparent;
  transition: transform 0.2s cubic-bezier(0, 0.79, 0.32, 1.28);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  bottom: 30px;
  right: 20px;
  background-color: var(--ion-color-primary);
  display: flex;
  width: 60px;
  height: 60px;
  color: white;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: var(--orwi-shadow);
  border: 2px solid white;
  z-index: 101;
}

.trans1 {
  transform: translate3d(-90px, 15px, 20px);
}

.trans2 {
  transform: translate3d(-90px, -70px, 20px);
}

.trans3 {
  transform: translate3d(-90px, -155px, 20px);
}

@keyframes trans3 {
  0% {
    transform: translate3d(50px, 40px, 0px);
    animation-timing-function: ease-in;
  }
  50% {
    transform: translate3d(50px, 50px, 0px);
    animation-timing-function: ease-out;
  }
  100% {
    transform: translate3d(50px, 40px, 0px);
  }
}
.text {
  background-color: rgba(0, 0, 0, 0.5803921569);
  color: white;
  padding: 4px;
  font-size: 12px;
  margin-bottom: 5px;
  transition: all 1s ease-in-out;
  visibility: hidden;
  position: absolute;
  right: 70px;
  width: 100px;
  top: 20px;
  text-align: center;
}

.text-open {
  visibility: visible;
}

.button {
  position: fixed;
  right: 20px;
  background-color: transparent;
  width: 60px;
  height: 60px;
  z-index: 14;
}

.button-cover {
  width: 50px;
  height: 50px;
  background-color: rgba(0, 0, 0, 0.4196078431);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/home/qr-button/qr-button.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,6CAAA;EAEA,aAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,8BAAA;EACA,uBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,mDAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;AAAJ;;AAGA;EACI,6BAAA;EACA,4DAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EAEA,eAAA;EACA,YAAA;EACA,WAAA;EACA,0CAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,8BAAA;EACA,uBAAA;EACA,YAAA;AADJ;;AAIA;EAEI,yCAAA;AAFJ;;AAKA;EAEI,0CAAA;AAHJ;;AAMA;EAEI,2CAAA;AAJJ;;AAOA;EACI;IACI,uCAAA;IACA,kCAAA;EAJN;EAME;IACI,uCAAA;IACA,mCAAA;EAJN;EAME;IACI,uCAAA;EAJN;AACF;AAOA;EACI,6CAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,kBAAA;EAEA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AANJ;;AASA;EACI,mBAAA;AANJ;;AASA;EACI,eAAA;EACA,WAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EAEA,WAAA;AAPJ;;AAUA;EACI,WAAA;EACA,YAAA;EACA,6CAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAPJ","sourcesContent":[".qr {\n    position: fixed;\n    bottom: 30px;\n    right: 20px;\n    background-color: var(--orwi-qr-button-color);\n\n    display: flex;\n    width: 60px;\n    height: 60px;\n    color: white;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    box-shadow: var(--orwi-shadow);\n    border: 2px solid white;\n    z-index: 102;\n}\n\n.orwi-actio-backdrop {\n    background-color: #abacad9e;\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    z-index: 100;\n    top: 0px;\n}\n\n.anim-button {\n    background-color: transparent;\n    transition: transform 0.2s cubic-bezier(0, 0.79, 0.32, 1.28);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    position: fixed;\n    bottom: 30px;\n    right: 20px;\n    background-color: var(--ion-color-primary);\n    display: flex;\n    width: 60px;\n    height: 60px;\n    color: white;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    box-shadow: var(--orwi-shadow);\n    border: 2px solid white;\n    z-index: 101;\n}\n\n.trans1 {\n    //transform: translate3d(-120px, 15px, 20px);\n    transform: translate3d(-90px, 15px, 20px);\n}\n\n.trans2 {\n    //transform: translate3d(-90px, -80px, 20px);\n    transform: translate3d(-90px, -70px, 20px);\n}\n\n.trans3 {\n    //transform: translate3d(10px, -150px, 20px);\n    transform: translate3d(-90px, -155px, 20px);\n}\n\n@keyframes trans3 {\n    0% {\n        transform: translate3d(50px, 40px, 0px);\n        animation-timing-function: ease-in;\n    }\n    50% {\n        transform: translate3d(50px, 50px, 0px);\n        animation-timing-function: ease-out;\n    }\n    100% {\n        transform: translate3d(50px, 40px, 0px);\n    }\n}\n\n.text {\n    background-color: #00000094;\n    color: white;\n    padding: 4px;\n    font-size: 12px;\n    margin-bottom: 5px;\n    transition: all 1s ease-in-out;\n    visibility: hidden;\n   \n    position: absolute;\n    right: 70px;\n    width: 100px;\n    top: 20px;\n    text-align: center;\n}\n\n.text-open {\n    visibility: visible;\n}\n\n.button {\n    position: fixed;\n    right: 20px;\n    background-color: transparent;\n    width: 60px;\n    height: 60px;\n\n    z-index: 14;\n}\n\n.button-cover {\n    width: 50px;\n    height: 50px;\n    background-color: #0000006b;\n    color: white;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
